// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2RuQR","title":"AfterBackImages_title__2nMlt","images":"AfterBackImages_images___U2ae"};